'use strict'

class Header{
    constructor(){
        this.main = document.getElementById('header');
        
        this._menuBtn = this.main.querySelector('.menu_btn');
        
        this._search = new HeaderSearch();
        
        this._isMenuOpen = false;
        
        
        Array.from(this.main.querySelectorAll('.search_btn')).forEach((btn) => {
            btn.addEventListener('click', this._onClickSearchBtn.bind(this));
        });
        
        this._menuBtn.addEventListener('click', this._onClickMenuBtn.bind(this));
    }

    closeMenu() {
        this._isMenuOpen = false;
        document.body.classList.remove('menu-show');
        [...document.querySelectorAll('.navigation__item')].forEach(item => item.classList.remove('navigation__item--open'));
    }

    openMenu() {
        this._isMenuOpen = true;
        document.body.classList.add('menu-show');
    }

    _onClickMenuBtn(e){
        if(!this._isMenuOpen){
            this.openMenu();
        }else{
            this.closeMenu();
        }
    }

    _onClickSearchBtn(e){
        e.preventDefault();

        this._search.show();
    }
}

class HeaderSearch{
    constructor(){
        this.main = document.getElementById('header_search');

        this._input = this.main.querySelector('input');

        this._closeBtn = this.main.querySelector('.close_btn');
        
        this._input.addEventListener('keydown', this._onKeyDownInput.bind(this));
        this._closeBtn.addEventListener('click', this._onClickCloseBtn.bind(this));
                
    }

    show(){
        document.body.classList.add('search--show');

        this._input.focus();
    }

    hide(){
        document.body.classList.remove('search--show');
    }

    _onKeyDownInput(e){
        if(e.keyCode == 13 && this._input.value.trim() != ''){
            window.location.href = App.baseUrl + App.sitemap.searcher.slug + this._input.value;
            
            this._input.value = '';
        }
    }

    _onClickCloseBtn(e){
        this.hide();
    }
}

export default Header;